module.exports = __webpack_public_path__ + "img/hemline sweep.9d1697ba.png";